import { useCallback } from 'react';
import { productAssociatedBundlesCache } from '../../cache';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
export const useProductAssociatedBundles = (productId, skip) => {
  const httpClient = useHttpClient();
  const getProductAssociatedBundles = useCallback(() => {
    return productAssociatedBundlesCache.get(productId, httpClient);
  }, [httpClient, productId]);
  return useAsyncFunction(getProductAssociatedBundles, {
    skip
  });
};